import { selectedModule$ } from '../appContainer/selectedModule$';
import { map } from 'rxjs';
import { AppModules } from '../appContainer/types';
import { distinctUntilChanged } from 'rxjs/operators';

export const isWorkspaceModule$ = selectedModule$.pipe(
  map(({ selectedModule }) => selectedModule === AppModules.WORKSPACES),
  distinctUntilChanged()
);
